module.exports={Remove:"Fjern"};